
import { Button, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import { useState } from 'react';

dayjs.extend(utc);


const ShippingLabelCard = ({object}) => {
    var labelframe = []
    const [showLabel, setShowLabel] = useState(false);

    labelframe.push(<Button key="button" sx={{width: 400, height: 32}} variant="outlined" onClick={(() => {setShowLabel(!showLabel)})} >{showLabel ? "Hide" : "Show / Print"}</Button>)
    if (showLabel) {
        labelframe.push(<iframe key="label" src={`data:application/pdf;base64,${object.labeldata}`} title="Label" width="400" height="600"/>);
    }

    return <Stack sx={{margin: 2}} spacing={2} direction={"column"}>
        <Typography variant="p">{object.carrier} / {object.service} - purchased {dayjs.utc(object.date).local().format("YYYY-DD-MM")}</Typography>
        {labelframe}
    </Stack>;
}

export { ShippingLabelCard };